<div class="modal-body width-800 height-900">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{enumSvc.getTranslation('ModalCoEditorComponent.Update')}}
    </span>
		<div class="content">
			<!-- loading Drawer -->
			<div *ngIf="oeGroupList.isLoading" class="splash loading">
				<div class="spinner">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
			<div class="layout-auto-1-auto">
				<exg-search-bar (Search)="oeGroupList.search($event)" [placeholder]="getRessource('SearchHolder')"
				                class="span-layout">
					<ng-template #rightTemplate>
						<i (click)="oeGroupList.loadData()" class="search-action far fa-sync"></i>
					</ng-template>
				</exg-search-bar>
				<div class="content">
					<exg-data-table #VCoeUserList
					                (ItemSelect)="oeGroupList.selectedRow"
					                [allowSingleSelection]="true"
					                [displayState]="0"
					                [hidden]="oeGroupList.isLoading"
					                [rowSource]="oeGroupList.data"
					                (RowChange)="oeGroupList.selectionChanged($event)"
					                containerClass="grid cols-12 app-modal-co-editor"
					                selectKey="oeID">
						<ng-template #headerTemplate>
							<div class="span-4 typo-small">{{enumSvc.getFieldCaption('Gruppe', 'grpBEZ')}}</div>
						</ng-template>
						<ng-template #rowTemplate let-row>
							<div class="span-5 typo-small">
								{{row.grpBEZ}}
							</div>
						</ng-template>
					</exg-data-table>
				</div>
				<exg-pager (PageChange)="oeGroupList.pageChanged($event)" *ngIf="true"
				           [pagingSource]="oeGroupList.paging">
				</exg-pager>
			</div>
		</div>
		<div class="spawn-modal-actions">
			<button class="md-btn" (click)="clickedSave()">Speichern</button>
			<button class="md-btn" (click)="clickedCancel()">Abbrechen</button>
		</div>
	</div>
</div>
